import { writable } from '../stores/_localStore.js'

export const subscriberEmail = writable('subscriberEmail', null)
